import React, { FC, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import MyAccount from '../my-account/MyAccount'
import Organizations from '../organizations/Organizations'
import ErrorHandlingInterceptor from '../error-handling/ErrorHandlingInterceptor'
import Settings from '../../pages/Settings'

const DashboardSwitch: FC = () => {
  const { nav } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (!nav) {
      navigate('/my-account')
    }
  }, [nav, navigate])

  switch (nav) {
    case 'my-account':
      return (
        <ErrorHandlingInterceptor>
          <MyAccount />
        </ErrorHandlingInterceptor>
      )
    case 'organizations':
      return (
        <ErrorHandlingInterceptor>
          <Organizations />
        </ErrorHandlingInterceptor>
      )
    case 'settings':
      return (
        <ErrorHandlingInterceptor>
          <Settings />
        </ErrorHandlingInterceptor>
      )
    default:
      return null
  }
}

export default DashboardSwitch
